import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as welcomeService from '../../services/welcome.service';

/**
 * Welcome for a new member, top of their dashboard (Jenn, 2026-10-27: her test
 * join "dumped me into the dashboard without any instructions about what to do,
 * when, where or how"). Jenn's welcome video (set in Team365 → Content Pushes →
 * Onboarding) and the How To course. Shows for a member's first 30 days or until
 * they close it.
 */
export default function WelcomeCard({ firstName }) {
  const [welcome, setWelcome] = useState(null);

  useEffect(() => {
    welcomeService.getMyWelcome().then(setWelcome).catch(() => setWelcome(null));
  }, []);

  if (!welcome?.show) return null;

  const close = () => {
    setWelcome(null);
    welcomeService.dismissMyWelcome().catch(() => {});
  };
  const portrait = welcome.videoShape === 'portrait';

  return (
    <div className="bg-white rounded-2xl shadow-sm p-5 sm:p-6 border border-reset-gold">
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <h2 className="font-serif text-xl font-bold text-reset-brown">Welcome to 365reset, {firstName}</h2>
          <p className="text-sm text-gray-600 mt-1">You're in. Here's where to start.</p>
        </div>
        <button onClick={close} className="text-xs text-gray-400 hover:text-reset-brown shrink-0">Close</button>
      </div>

      {welcome.videoUrl && (
        <div className={`mb-5 ${portrait ? 'max-w-[300px] mx-auto' : ''}`}>
          <div className={`relative w-full overflow-hidden rounded-xl bg-black ${portrait ? 'aspect-[9/16]' : 'aspect-video'}`}>
            <iframe
              src={welcome.videoUrl}
              title="A welcome from Jenn"
              className="absolute inset-0 w-full h-full"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      )}

      <ol className="space-y-3 text-sm text-gray-700">
        <li className="flex gap-3">
          <span className="font-serif text-lg text-reset-terracotta leading-none">1</span>
          <span>
            {welcome.course
              ? <>Start with <Link to={welcome.course.url} className="font-semibold text-reset-terracotta hover:underline">{welcome.course.title}</Link>. It shows you how everything here works.</>
              : <>Visit the <Link to="/dashboard/learning-lab" className="font-semibold text-reset-terracotta hover:underline">Learning Lab</Link> and pick a course.</>}
          </span>
        </li>
        <li className="flex gap-3">
          <span className="font-serif text-lg text-reset-terracotta leading-none">2</span>
          <span>Look at this week's <Link to="/dashboard/events" className="font-semibold text-reset-terracotta hover:underline">live events</Link> and choose one that fits your day. Camera on or off, your choice.</span>
        </li>
        <li className="flex gap-3">
          <span className="font-serif text-lg text-reset-terracotta leading-none">3</span>
          <span><Link to="/dashboard/book-a-call" className="font-semibold text-reset-terracotta hover:underline">Book a call with Jenn</Link> to build your reset path together.</span>
        </li>
      </ol>

      {welcome.course && (
        <Link to={welcome.course.url} className="mt-5 inline-block bg-reset-terracotta text-white text-sm font-semibold px-5 py-2.5 rounded-xl hover:opacity-90">
          Start here
        </Link>
      )}
    </div>
  );
}
